<template>
    <editor
        :tinymceScriptSrc="'/js/tinymce/tinymce.min.js'"
        v-model="content"
        @input="onEditorInput"
        :init="{
          height: 400,
          width: '100%',
          menubar: 'file edit view insert format table help',
          plugins: [
            'advlist autolink lists link image charmap preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table code help wordcount',
            'emoticons template codesample autosave hr pagebreak',
            'save directionality textpattern noneditable',
            'quickbars '
          ],
          toolbar: [
            'undo redo | styleselect | bold italic underline strikethrough | forecolor backcolor | fontselect fontsizeselect',
            'alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | link image media',
            'blockquote subscript superscript | removeformat | charmap emoticons | code fullscreen preview',
            'insertfile template hr pagebreak | ltr rtl | visualblocks visualchars '
          ].join(' | '),
          toolbar_sticky: true,
          autosave_interval: '30s',
          autosave_retention: '2m',
          image_advtab: true,
          image_caption: true,
          imagetools_cors_hosts: ['mydomain.com'],
          quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
          contextmenu: 'link image table',
          branding: false,

          skin_url: '/js/tinymce/skins/ui/oxide',
          content_css: '/js/tinymce/skins/content/default/content.css',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } h1,h2,h3 { color:#333; }',

          file_picker_callback: this.handleFilePicker
        }"
    />

</template>

<script>
import {defineComponent} from 'vue'
import Editor from '@tinymce/tinymce-vue'

export default defineComponent({
    name: "TinyMce",
    props: {
        propsValue: String,
        uploadHandler: {
            type: Function,
            required: true
        }
    },
    components: {Editor},
    data() {
        return {
            content: null
        }
    },
    methods: {
        onEditorInput(newContent) {
            this.$emit('update-content', newContent)
        },
        async handleFilePicker(callback, value, meta) {
            if (meta.filetype === 'image') {
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'

                input.onchange = async () => {
                    const file = input.files[0]
                    const formData = new FormData()
                    formData.append('files[]', file)

                    try {
                        const { data: response } = await this.uploadHandler(formData)
                        const result = response[0]

                        const imageUrl = `/uploads${result.file_path}`
                        callback(imageUrl, { alt: result.name })

                    } catch (error) {
                        console.error('Upload failed:', error)
                        this.$showErrorMessage('Upload failed')
                    }
                }
                input.click()
            }
        }

    },

    watch: {
        propsValue: {
            immediate: true,
            handler(val) {
                this.content = val
            }
        }
    }
})
</script>

<style scoped>

</style>
